export default "__VITE_ASSET__BtvaX78x__"